/**
 * Frontend PII Scrubber
 * Mirrors the backend utils/piiScrubber.js patterns.
 * Applied before any trace data is exported to CSV/JSON or rendered in exports.
 */

const PII_PATTERNS = {
  EMAIL: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
  PHONE: /(?:\+?\d{1,3}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g,
  SSN: /\b\d{3}[-.\s]?\d{2}[-.\s]?\d{4}\b/g,
  // More specific credit card pattern — excludes pure hex strings (MongoDB ObjectIDs)
  CREDIT_CARD: /\b(?:\d[ -]*?){13,16}\b(?![a-f])/gi,
  IBAN: /\b[A-Z]{2}\d{2}[A-Z\d]{11,30}\b/g,
};

export function scrubString(text: string): string {
  if (typeof text !== 'string') return text;
  let s = text;
  s = s.replace(PII_PATTERNS.EMAIL, '[REDACTED_EMAIL]');
  s = s.replace(PII_PATTERNS.SSN, '[REDACTED_SSN]');
  s = s.replace(PII_PATTERNS.CREDIT_CARD, '[REDACTED_CREDIT_CARD]');
  s = s.replace(PII_PATTERNS.IBAN, '[REDACTED_IBAN]');
  s = s.replace(PII_PATTERNS.PHONE, '[REDACTED_PHONE]');
  return s;
}

export function scrubPayload<T>(data: T): T {
  if (data === null || data === undefined) return data;
  if (typeof data === 'string') return scrubString(data) as unknown as T;
  if (Array.isArray(data)) return data.map(item => scrubPayload(item)) as unknown as T;
  if (typeof data === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
      result[key] = scrubPayload(value);
    }
    return result as T;
  }
  return data;
}
